import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "../store";

export interface UiState {
    /** Whether the keyboard-shortcuts help overlay is open. */
    shortcutsOpen: boolean;
}

const initialState: UiState = {
    shortcutsOpen: false,
};

const uiSlice = createSlice({
    name: "ui",
    initialState,
    reducers: {
        openShortcuts(state) {
            state.shortcutsOpen = true;
        },
        closeShortcuts(state) {
            state.shortcutsOpen = false;
        },
        toggleShortcuts(state) {
            state.shortcutsOpen = !state.shortcutsOpen;
        },
    },
});

export const { openShortcuts, closeShortcuts, toggleShortcuts } =
    uiSlice.actions;

export const selectUi = (state: RootState) => state.ui;
export const uiReducer = uiSlice.reducer;
export default uiSlice.reducer;
